<template>
  <div>
    <el-card>
      <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:15px;">
        <h3>后台管理员账号管理</h3>
        <el-button type="primary" @click="openAddDialog">新增管理员</el-button>
      </div>
      <el-table :data="tableData" border stripe>
        <el-table-column prop="id" label="ID" width="80"/>
        <el-table-column prop="username" label="管理员账号"/>
        <el-table-column prop="createTime" label="创建时间" width="180"/>
        <el-table-column prop="updateTime" label="更新时间" width="180"/>
        <el-table-column label="操作" width="220">
          <template slot-scope="scope">
            <el-button size="mini" @click="openEdit(scope.row)">编辑</el-button>
            <el-button
              v-if="scope.row.id !== 1"
              size="mini"
              type="danger"
              @click="handleDel(scope.row)"
            >删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        style="margin-top:15px;text-align:right;"
        background
        layout="total, prev, pager, next, jumper"
        :total="total"
        :page-size="pageSize"
        :current-page.sync="currentPage"
        @current-change="getList"
      />
    </el-card>

    <el-dialog title="管理员信息" :visible.sync="dialogVisible">
      <el-form :model="form" label-width="100px">
        <el-form-item label="用户名">
          <el-input v-model="form.username"></el-input>
        </el-form-item>
        <el-form-item label="密码" v-if="!isEdit">
          <el-input v-model="form.password" show-password placeholder="请输入密码"></el-input>
        </el-form-item>
        <el-form-item label="密码" v-if="isEdit">
          <el-input v-model="form.password" placeholder="留空则不修改密码" show-password></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitForm">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import adminRequest from '@/utils/adminRequest'
export default {
  data() {
    return {
      tableData: [],
      dialogVisible: false,
      isEdit: false,
      currentPage: 1,
      pageSize: 20,
      total: 0,
      form: {
        id: null,
        username: '',
        password: ''
      }
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    async getList() {
      try {
        const res = await adminRequest.get('/list', {
          params: { page: this.currentPage, pageSize: this.pageSize }
        })
        this.tableData = res.data?.list || []
        this.total = res.data?.total || 0
      } catch (err) {
        console.error('请求管理员列表失败：', err)
        this.tableData = []
      }
    },
    openAddDialog() {
      this.isEdit = false
      this.form = { id: null, username: '', password: '' }
      this.dialogVisible = true
    },
    openEdit(row) {
      this.isEdit = true
      this.form = { ...row, password: '' }
      this.dialogVisible = true
    },
    async submitForm() {
      if (!this.form.username || !this.form.username.trim()) {
        this.$message.error('请输入用户名')
        return
      }
      if (!this.isEdit && !this.form.password) {
        this.$message.error('请输入密码')
        return
      }
      try {
        let res
        if (this.isEdit) {
          res = await adminRequest.put('/edit', this.form)
        } else {
          res = await adminRequest.post('/add', this.form)
        }
        if (res.success) {
          this.dialogVisible = false
          this.$message.success('保存成功')
          this.getList()
        } else {
          this.$message.error(res.msg || '保存失败')
        }
      } catch (err) {
        console.error(err)
        this.$message.error('保存失败')
      }
    },
    async handleDel(row) {
      this.$confirm(`确定删除管理员【${row.username}】？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const res = await adminRequest.delete('/delete', {
            data: { id: row.id }
          })
          if (res.success) {
            this.$message.success('删除成功')
            this.getList()
          } else {
            this.$message.error(res.msg || '删除失败')
          }
        } catch (err) {
          console.error(err)
          this.$message.error('删除失败')
        }
      }).catch(() => {})
    }
  }
}
</script>